

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const REPLYTOCOMMENT= createAsyncThunk(
  "replyToComment/replyToComment",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const replyToCommentSlice = createSlice({
  name: "replyToCommentSlice",
  initialState: {
    replyToComment: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfreplyToComment: (state) => {
        state.replyToComment.loading = false
        state.replyToComment.error = false
        state.replyToComment.data = []
        state.replyToComment.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REPLYTOCOMMENT.fulfilled, (state, action) => {
      state.replyToComment = {
        ...state.replyToComment,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REPLYTOCOMMENT.pending, (state, action) => {
      state.replyToComment = {
        ...state.replyToComment,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REPLYTOCOMMENT.rejected, (state, action) => {
      state.replyToComment = {
        ...state.replyToComment,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const replyToCommentAction = {
    REPLYTOCOMMENT,
};

export { replyToCommentAction };
export default replyToCommentSlice.reducer;
export const {setInitialStateOfreplyToComment} = replyToCommentSlice.actions